import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { useEffect } from "react";
import { notifyError } from "@/lib/notifications.ts";
import { isDevelopment } from "@/utils/env.ts";

export default function useMutationApiClient<T>(opts: UseMutationOptions<T>) {
    const { error, ...rest } = useMutation(opts);

    useEffect(() => {
        if (!error || !isDevelopment()) return;

        notifyError(error.message);
    }, [error]);

    return { error, ...rest };
}
